import { render, staticRenderFns } from "./GroupConf.vue?vue&type=template&id=9971311c&scoped=true&"
import script from "./GroupConf.vue?vue&type=script&lang=js&"
export * from "./GroupConf.vue?vue&type=script&lang=js&"
import style0 from "./GroupConf.vue?vue&type=style&index=0&id=9971311c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9971311c",
  null
  
)

export default component.exports